const productDetailPage = {
  key: 'productDetailPage',
  name: 'Product Detail',
  headDescriptionLabel: `Buy the {title} in the official PetSafe® store for your pet.`,
};

exports.productDetailPage = productDetailPage;
